import { ProjectionFilterOperationEnum } from '../enums/projection-filter-operation.enum';

/**
 * Filter to apply to a nested collection
 */
export class ProjectionFilter {
	/**
	 * Field name to filter on
	 */
	field!: string;

	/**
	 * Operation to perform
	 */
	operation!: ProjectionFilterOperationEnum;

	/**
	 * Value to compare against (not required for EXISTS operation)
	 */
	value?: any;
}
